module.exports = __webpack_public_path__ + "static/media/AddUser.69ef5232.svg";